/* @flow weak */

'use strict';

const React = require('react');
const Reflux = require('reflux');
import { map, get } from 'lodash';

const Config = require('../../configs/Config.js');
const Loader = require('../../loaders');
const ln = Loader.ln || 'en_US';

const QuestionStore = require('../../stores/QuestionStore.jsx');
const ValidatorStore = require('../../stores/ValidatorStore.jsx');
const QuestionRenderer = require('./QuestionRenderer.jsx');

import { VelocityComponent } from 'velocity-react';

import { Scroll, Helpers } from 'react-scroll';

const QuestionGroup = React.createClass({
  mixins: [
    Reflux.connect(ValidatorStore, 'validationData'),
    Helpers.Scroll,
    Helpers.Element
  ],

  getInitialState() {
    return {
      nextButtonClicked: false
    }
  },

  propTypes: {
    group: React.PropTypes.string.isRequired,
    isLast: React.PropTypes.bool.isRequired,
    stepNumber: React.PropTypes.number.isRequired,
    groupTabIndex: React.PropTypes.number.isRequired,
    active: React.PropTypes.bool.isRequired,
    questions: React.PropTypes.array.isRequired,
    clickHandler: React.PropTypes.func.isRequired,
    clickNextButtonHandler: React.PropTypes.func.isRequired
  },

  handleTabFocus() {
    if (!this.props.active) {
      this.handleHeaderClick();
    }
  },

  handleHeaderClick() {
    this.props.clickHandler();
  },

  handleNextButtonClick() {
    this.setState(Object.assign({}, this.state, {nextButtonClicked: true}));
    const { invalidGroups } = this.state.validationData;
    const groupValid = invalidGroups.indexOf(this.props.group) === -1;
    if (groupValid) this.props.clickNextButtonHandler(); 
  },

  renderQuestions() {
    const { questions: questionValidationData, hasUserSubmitted } = this.state.validationData;

    return (
      map(this.props.questions, (question, index) => {
        const questions = this.props.questions;
        const isLast = index == questions.length - 1;
        const previousQuestionId = get(questions[index - 1], 'id');
        const previousChildCount = previousQuestionId ?
          get(QuestionStore.getChildQuestions(previousQuestionId), 'length')
          : 0;

        return (
          <QuestionRenderer 
            key={question.id} 
            question={question} 
            validationData={questionValidationData}
            isLast={isLast}
            hasUserSubmitted={hasUserSubmitted || this.state.nextButtonClicked}
            tabIndex={this.props.groupTabIndex + index + previousChildCount + 1} />
        );
      })
    );
  },

  renderNextButton(showError) {
    const isAvailable = get(Config, 'features.questionNextButton');

    const defaultTitle = this.props.isLast 
      ? (Config.features.finishButtonText[ln] || Config.features.finishButtonText['en_US']) 
      : (Config.features.nextButtonText[ln] || Config.features.nextButtonText['en_US']);
    return (isAvailable ?
      <div className="uc-next-button-container">
        <div className={`uc-constraint-message uc-error uc-group-error ${showError ? '' : 'uc-hide-error'}`}>
                  * {Config.features.completeRequiredFieldsText[ln] || Config.features.completeRequiredFieldsText['en_US']}
        </div>
      <button className={`uc-next-button`} onClick={this.handleNextButtonClick}>
        {defaultTitle}
      </button>
    </div> : '');
  },

  render() {
    const { valid, invalidGroups, hasUserSubmitted } = this.state.validationData;
    const activeClass = this.props.active ? ' uc-active' : '';
    const groupValid = invalidGroups.indexOf(this.props.group) === -1;
    // if valid === null, ValidatorStore has not run through a single validation yet, so no visual indicators should be displayed
    const completeClass = valid !== null && groupValid ? ' uc-complete' : '';
    const showError = !groupValid && (hasUserSubmitted || this.state.nextButtonClicked);
    const alertClass = showError ? ' uc-alert' : '';

    return (
      <div id={'uc-question-group-' + this.props.group} 
        className={`uc-question-group${activeClass}${completeClass}${alertClass}`}>
        <div className="uc-question-group-heading" role='section' onClick={this.handleHeaderClick}>
          <div className="uc-step-number">
            {this.props.stepNumber}
          </div>

          <div className="uc-question-group-name">
            {this.props.group}
          </div>

          <div className="tabTarget" 
            onFocus={this.handleTabFocus} 
            tabIndex={this.props.groupTabIndex} 
            style={{ width: '0', height: '0', top: '0', left: '0' }}></div>
        </div>

        <VelocityComponent component="div"
          animation={ this.props.active ? 'slideDown' : 'slideUp' } 
          duration={300} 
          style={ this.props.active ? {height: ''} : null }
          complete={ this.props.active && this.props.userClicked ? this.onClick : null }
          >

          <div className='uc-question-group-questions'>
            {this.renderQuestions()}
            {this.renderNextButton(showError)}
          </div>
        </VelocityComponent>
      </div>
    );
  }
});

module.exports = QuestionGroup;


// WEBPACK FOOTER //
// ./src/base/scripts/components/renderers/QuestionGroup.jsx